import InvestorType from 'src/entities/InvestorType';
import * as GetInvestorTypeTypes from 'src/actions/investor-type/get/Types';
import {
  GetInvestorTypeAction,
  GetInvestorTypeSuccess
} from 'src/actions/investor-type/get/GetInvestorType.actions';

export interface GetInvestorTypeState {
  investorType?: InvestorType;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetInvestorTypeState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function GetInvestorTypeReducer(state: GetInvestorTypeState = initialState,
                                       action: GetInvestorTypeAction):
  GetInvestorTypeState {
  switch (action.type) {
    case GetInvestorTypeTypes.GET_INVESTOR_TYPE_ATTEMPT:
      return {...state, loading: true, error: false};
    case GetInvestorTypeTypes.GET_INVESTOR_TYPE_SUCCESS:
      const investorType: InvestorType = (
        action as GetInvestorTypeSuccess).payload;
      return {...state, investorType: investorType, loading: false, error: false};
    case GetInvestorTypeTypes.GET_INVESTOR_TYPE_FAILURE:
      return {
        ...state,
        investorType: undefined,
        loading: false,
        error: true,
        errorMessage: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/investor-type/GetInvestorTypeReducer.tsx